const validator = (e, t) => {
    const l = (e, t, l) => {
        let a = e.parentElement.querySelectorAll(".validate");
        [].forEach.call(a, (e) => {
            e.innerText = l ? (null != t ? t : "wrong Input") : "";
        });
    };
    let a = document.querySelectorAll(e);
    [].forEach.call(a, (e) => {
        e.addEventListener("submit", (a) => {
            a.preventDefault();
            let r = [];
            var u = e.querySelectorAll(".form-group");
            let c = e.querySelector(".password");
            var s = !1,
                n = /^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{2,}$/i;
            if (
                ([].forEach.call(u, (e) => {
                    !(function () {
                        let t = e.querySelectorAll("input, select, textarea");
                        [].forEach.call(t, (e) => {
                            let t = e.getAttribute("data-rule"),
                                a = e.getAttribute("data-msg");
                            if (null != t) {
                                var u = !1,
                                    i = t.indexOf(":", 0);
                                if (i >= 0) {
                                    var o = t.substr(i + 1, t.length);
                                    t = t.substr(0, i);
                                } else t = t.substr(i + 1, t.length);
                                switch (t) {
                                    case "required":
                                        "" === e.value &&
                                            ((s = u = !0), r.push(e));
                                        break;
                                    case "minLen":
                                        e.value.length < parseInt(o) &&
                                            ((s = u = !0), r.push(e));
                                        break;
                                    case "confirmPassword":
                                        c.value !== e.value &&
                                            ((s = u = !0), r.push(e));
                                        break;
                                    case "email":
                                        n.test(e.value) ||
                                            ((s = u = !0), r.push(e));
                                        break;
                                    case "checked":
                                        e.checked || ((s = u = !0), r.push(e));
                                        break;
                                    case "select":
                                        ("" !== e.value &&
                                            null !== e.value &&
                                            void 0 !== e.value) ||
                                            ((s = u = !0), r.push(e));
                                        break;
                                    case "radio":
                                        !e.querySelectorAll(
                                            "input[type=radio]:checked"
                                        ).length > 0 &&
                                            ((s = u = !0), r.push(e));
                                    case "regexp":
                                        (o = `${o}`).test(e.value) ||
                                            ((s = u = !0), r.push(e));
                                        break;
                                }
                                l(e, a, u);
                            }
                        });
                    })(),
                        (function () {
                            let t = e.querySelectorAll(".validate-input");
                            [].forEach.call(t, (e) => {
                                let t = e.getAttribute("data-rule"),
                                    a = e.getAttribute("data-msg"),
                                    u = e.querySelectorAll(
                                        "input[type='radio']:checked"
                                    ),
                                    c = e.querySelectorAll(
                                        "input[type='checkbox']:checked"
                                    );
                                if (null != t) {
                                    var n = !1,
                                        i = t.indexOf(":", 0);
                                    if (i >= 0) {
                                        var o = t.substr(i + 1, t.length);
                                        t = t.substr(0, i);
                                    } else t = t.substr(i + 1, t.length);
                                    switch (t) {
                                        case "radio":
                                            u.length <= 0 &&
                                                ((s = n = !0), r.push(e));
                                            break;
                                        case "maxCheck":
                                            c.length > parseInt(o) &&
                                                ((s = n = !0), r.push(e));
                                            break;
                                        case "minCheck":
                                            c.length < parseInt(o) &&
                                                ((s = n = !0), r.push(e));
                                            break;
                                    }
                                    l(e, a, n);
                                }
                            });
                        })();
                }),
                r.length > 0 &&
                    ((e) => {
                        e.parentElement
                            .querySelector(".validate")
                            .scrollIntoView({
                                block: "center",
                                behavior: "smooth",
                            });
                    })(r[0]),
                s)
            )
                return !1;
            t();
        });
    });
};

export default validator;
